import { AccountHistory } from '@/features/profile'

export default function History() {
    return (
        <div className="px-4 py-8 lg:px-0">
            <AccountHistory />
        </div>
    )
}
